import { Component } from '@angular/core';
import { StoreState } from '@/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.css'],
})
export class PageLoaderComponent {
  state: Partial<StoreState['pageLoadingAnimation']> = {};
  constructor(
    private store: Store<StoreState>,
  ) {
    this.store.select('pageLoadingAnimation').subscribe({
      next: (state) => {
        this.state = state;
      },
    });
  }
}
